var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fragment",
    [
      _c("step-navbar", {
        attrs: {
          pages: _vm.pages,
          current: _vm.navbarPage,
          "show-controls": false,
        },
      }),
      _vm._v(" "),
      _c("registration-steps", {
        attrs: {
          "current-page": _vm.currentPage,
          "loading-state": { creating: _vm.creating, verifying: _vm.verifying },
        },
        on: {
          create: _vm.handleCreateAccount,
          verify: _vm.handleVerifyEmail,
          "resend-code": _vm.handleResendCode,
        },
      }),
      _vm._v(" "),
      _c("page-footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }